import { Box } from "@mui/material";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { OREDER_STATUS } from "../../../helper/Constants";
import { useTranslation } from "react-i18next";

const Payment = ({ order }) => {
  const [t] = useTranslation();
  const contacts = useSelector((state) => state.contacts.contacts);

  const getUPILink = () => {
    const total =
      order?.items?.reduce(
        (a, v) => (a = a + parseFloat(v.offerPrice) * parseFloat(v.count)),
        0,
      ) +
      parseFloat(order?.deliveryFee) -
      parseFloat(order?.discount);
    if (total > 0) {
      return `upi://pay?pa=${encodeURIComponent(contacts?.upiId)}&pn=${encodeURIComponent(contacts?.upiName)}&am=
      ${encodeURIComponent(total)}&cu=${encodeURIComponent(contacts?.upiCurrency)}&tn=${encodeURIComponent(order?.orderNo)}`;
    }
    return "";
  };
  if (
    order?.status === OREDER_STATUS.ORDERED ||
    order?.status === OREDER_STATUS.PAYMENT_FAILED
  ) {
    return (
      <Box>
        <Box sx={{ textAlign: "center", padding: "5px" }}>
          <QRCode
            value={getUPILink(order)}
            size={120}
            viewBox={`0 0 150 150`}
          />
        </Box>
        <Box
          sx={{
            textAlign: "center",
            borderTop: "1px solid #ababab50",
            paddingLeft: "5px",
          }}
        >
          <img
            src="./images/Gpay.svg"
            alt="Gpay"
            height="16px"
            style={{ padding: "2px" }}
          />
          <img
            src="./images/Paytm.svg"
            alt="Paytm"
            height="16px"
            style={{ padding: "2px" }}
          />
          <img
            src="./images/PhonePe.svg"
            alt="PhonePe"
            height="16px"
            style={{ padding: "2px" }}
          />
          <img
            src="./images/UPI.svg"
            alt="UPI"
            height="16px"
            style={{ padding: "2px" }}
          />
        </Box>
      </Box>
    );
  } else if (order?.status === OREDER_STATUS.DELETED) {
    return (
      <Box sx={{ paddingRight: "5px" }}>
        {t("my-orders.refund.successfull")}
      </Box>
    );
  } else {
    return (
      <Box sx={{ paddingRight: "5px" }}>
        {t("my-orders.payment.successfull")}
      </Box>
    );
  }
};

export default Payment;
